import { ROUTES } from "@src/common/constants";

/** Electron production loads `/index.html`; map that to the Ask route. */
export function getAuthReturnPathname(
	pathname: string = window.location.pathname,
): string {
	return pathname === "/index.html" ? ROUTES.ask : pathname;
}

export function getAuthReturnTo(
	pathname: string = window.location.pathname,
	search: string = window.location.search,
): string {
	return `${getAuthReturnPathname(pathname)}${search}`;
}

/**
 * Determine whether to open Auth0's `/u/signup` screen first (`screen_hint: "signup"`):
 * - Explicit marketing `/signup` entry
 * - Invite routes (`/invite/:code`) or referral links (`?ref=…`)
 * - Otherwise default to login (no screen_hint)
 */
export function shouldUseSignupScreenHint(
	pathname: string = getAuthReturnPathname(),
	referralCode: string | null = null,
): boolean {
	if (pathname === ROUTES.signup) {
		return true;
	}
	return pathname.startsWith(`${ROUTES.invite}/`) || referralCode !== null;
}
